import { HTMLAttributes } from 'react'
import { twMerge } from 'tailwind-merge'

interface ToastTitleProps extends HTMLAttributes<HTMLDivElement> {
  className?: string
}

export function ToastTitle({ className, children, ...props }: ToastTitleProps) {
  return (
    <div className={twMerge('text-foreground text-md line-clamp-3 min-w-0 font-[550]', className)} {...props}>
      {children}
    </div>
  )
}
